import React, { FunctionComponent } from 'react';
import { useFormContext, useStepper } from '../../../../hooks';
import {
  CalculatorsStudentLoanFormFields,
  CalculatorsStudentLoanResult
} from '../../../../@types/features/calculators';
import { CalculatorStudentLoanSummary } from './calculator-student-loan-summary';
import useMediaQuery from '../../../../hooks/use-media';
import { mainMediaMobile } from '../../../../utils';
import { StepperPrevious } from '../../../shared/general';
import { Button } from '@chakra-ui/react';

export const CalculatorStudentLoanResult: FunctionComponent = () => {
  const { result, updateResult, form } = useFormContext<
    CalculatorsStudentLoanResult,
    CalculatorsStudentLoanFormFields
  >();
  const isMobile = useMediaQuery(mainMediaMobile);
  const { steps, currentStep, setCurrentStep, setStepActive } = useStepper();

  const goToCalculator = () => {
    const queryParams = new URLSearchParams({
      Klant_Jaarinkomen: form.applicantYearlyIncome,
      Klant_Leeftijd: form.applicantAge,
      HeeftPartner: form.withPartner ? '1' : '0',
      Partner_Jaarinkomen: form.partnerYearlyIncome,
      Partner_Leeftijd: form.partnerAge,
      Student_Debt_Amount: form.studentDebtAmount
    });

    window.location.href = `/zelf-berekenen/hoeveel-kan-ik-lenen/calculator/${queryParams}`;
  };

  const handleBackClick = () => {
    if (currentStep && currentStep !== 0) {
      const id = currentStep - 1;
      setStepActive(currentStep, true);
      setCurrentStep(id);
      updateResult(null);
    }
  };
  return (
    <div>
      {result && isMobile && currentStep && (
        <div>
          <StepperPrevious
            currentStep={currentStep}
            totalSteps={steps.length}
            title={`Vorige stap`}
            handleBackClick={handleBackClick}
          />
          <div className={`pt-4`}>
            <CalculatorStudentLoanSummary result={result}></CalculatorStudentLoanSummary>
          </div>
        </div>
      )}
      <div className={`rounded shadow shadow-shadow-500 bg-white mb-4`}>
        <div className={`p-8 md:flex md:justify-between`}>
          <div>
            <p className={`text-gray-500`}>Je maximale hypotheek</p>
            <div className={`text-[40px] tracking-[-1px]`}>{result?.maxMortgageAmount || 0}</div>
          </div>
          {result && !isMobile && currentStep && (
            <div>
              <StepperPrevious
                variant={`horizontal`}
                title={`Vorige stap`}
                handleBackClick={handleBackClick}
              />
            </div>
          )}
        </div>
        <hr />
        <div className={`p-8 flex`}>
          <div className={`mr-16`}>
            <p className={`text-gray-500`}>Aflossing studieschuld</p>
            <div className={`text-[20px] tracking-[-1px]`}>{result?.studentDebtAmount}</div>
          </div>
          <div>
            <p className={`text-gray-500`}>Maandlasten</p>
            <div className={`text-[20px] tracking-[-1px]`}>{result?.monthlyPayment}</div>
          </div>
        </div>
      </div>
      <div>
        <p className={`my-8`}>
          In deze berekening gaan we uit van een annuïtaire hypotheek en gebruiken we de laagste
          rente op dit moment met rentevaste periode van 10 jaar. We houden alleen rekening met je
          inkomen en die van je eventuele partner en de studieschuld. Heb je nog andere financiële
          verplichtingen zoals een private lease auto of heb je ook een lopende hypotheek, dan kan
          je maximale hypotheek lager uitvallen. In onze uitgebreide maximale hypotheek berekening
          kan je verder rekenen.
        </p>
        <Button onClick={goToCalculator} colorScheme={`orange`}>
          Verder rekenen
        </Button>
      </div>
    </div>
  );
};
